<template>
  <section class="bg-lifeboost-red-lighter" id="the-products">
    <div id="steps" class="px-4 py-10 mx-auto max-w-screen-xl md:py-20">

      <h5 class="mb-10 font-bold text-center h2">
        Choose The Bags You’d Like
      </h5>

      <div class="flex relative flex-wrap items-center w-full">
        <div class="w-full text-center lg:w-5/12">
          <div class="mx-auto space-y-3 max-w-sm">
            <div class="h2">
              {{ FilteredPacks[state.active.packs].Name }}
              <!-- {{ items[state.active.items].Variants[state.active.variants].Pack[state.active.packs].Name }} -->
              
            </div>

            <p class="text-center text-gray-500 textp">
              {{ FilteredPacks[state.active.packs].Text }}
            </p>

          </div>
          <div class="mx-auto mt-4 mb-2 h-52 sm:h-80">
            <nuxt-img width="240" height="342" format="webp" 
              :src="FilteredPacks[state.active.packs].Image.url"
              alt="product swatch" class="object-contain mx-auto w-full h-full" loading="lazy"
              sizes="xs:110px sm:140px md:177px lg:157px xl:231px" />
          </div>

          <div class="grid grid-cols-2 justify-center mx-auto max-w-md lg:max-w-sm">
            <div>
              <svg role="presentation" class="mx-auto w-full" xmlns="http://www.w3.org/2000/svg" width="45.018" height="31.061"
                viewBox="0 0 45.018 32.95">
                <g id="Group_4204" data-name="Group 4204" transform="translate(0 -2.1)">
                  <g id="Group_4181" data-name="Group 4181" transform="translate(50.953 11.809) rotate(111)">
                    <g id="Ellipse_106" data-name="Ellipse 106"
                      transform="matrix(0.809, -0.588, 0.588, 0.809, 0, 12.032)" fill="#f5f1ed" stroke="#000"
                      stroke-width="1">
                      <ellipse cx="10.235" cy="12.928" rx="10.235" ry="12.928" stroke="none"></ellipse>
                      <ellipse cx="10.235" cy="12.928" rx="9.735" ry="12.428" fill="none"></ellipse>
                    </g>
                    <path id="Path_784" data-name="Path 784" d="M0,0S5.434.912,6.492,10.531,11.543,21.59,11.543,21.59"
                      transform="translate(9.479 5.856)" fill="none" stroke="#000" stroke-width="1"></path>
                  </g>
                  <g id="Group_4180" data-name="Group 4180" transform="translate(0 2.1)">
                    <g id="Ellipse_106-2" data-name="Ellipse 106"
                      transform="matrix(0.809, -0.588, 0.588, 0.809, 0, 12.032)" fill="#f5f1ed" stroke="#000"
                      stroke-width="1">
                      <ellipse cx="10.235" cy="12.928" rx="10.235" ry="12.928" stroke="none"></ellipse>
                      <ellipse cx="10.235" cy="12.928" rx="9.735" ry="12.428" fill="none"></ellipse>
                    </g>
                    <path id="Path_784-2" data-name="Path 784"
                      d="M-20555.338-18839.539s5.434.912,6.492,10.531,5.051,11.059,5.051,11.059"
                      transform="translate(20564.816 18845.393)" fill="none" stroke="#000" stroke-width="1"></path>
                  </g>
                </g>
              </svg>

              <div class="mx-auto mt-2 leading-4 text-15 max-w-24">
                Low Acid Beans
              </div>
            </div>


            <!-- <div>
              <svg role="presentation" class="mx-auto" xmlns="http://www.w3.org/2000/svg" width="28.639" height="31.061"
                viewBox="0 0 28.639 31.061">
                <g id="Group_4205" data-name="Group 4205" transform="translate(0.527 0.503)">
                  <g id="Group_52" data-name="Group 52">
                    <path id="Path_392" data-name="Path 392"
                      d="M2746.088,2702.756s-1.305-.72-.8-2.989a3.263,3.263,0,0,1,2.227-2.647h19.156s1.764-.084,2.311,2.647,3.8,22.433,3.8,22.433.051,4.886-3.688,4.97c-3.271.074-3.849-2.478-3.664-3.709h0l1.239-9.41,2.418-13.632"
                      transform="translate(-2745.171 -2697.121)" fill="none" stroke="#000" stroke-width="1"></path>
                    <path id="Path_393" data-name="Path 393"
                      d="M2803.814,2697.254s-3.228.268-3.224,3.339a2.1,2.1,0,0,0,1.878,2.229s1.473.187,1.346-1.683h-1.754"
                      transform="translate(-2782.578 -2697.21)" fill="none" stroke="#000" stroke-width="1"></path>
                    <path id="Path_394" data-name="Path 394" d="M2767.112,2714.379h-19.264"
                      transform="translate(-2746.978 -2708.77)" fill="none" stroke="#000" stroke-width="1"></path>
                    <path id="Path_395" data-name="Path 395"
                      d="M2750.313,2714.593l-3.337,18.759s-1.422,5.526,3.2,5.591,20.484.007,20.484.007"
                      transform="translate(-2746.25 -2708.915)" fill="none" stroke="#000" stroke-width="1"></path>
                  </g>
                  <g id="Group_467" data-name="Group 467" transform="translate(7.97 10.914)">
                    <path id="Path_433" data-name="Path 433"
                      d="M242.779,4483.758a4.575,4.575,0,0,1,1.434-3.02c1.362-1.594,2.549-4.451,1.776-6.646a9.5,9.5,0,0,0-3.923-4.884s-2.507,4.074,2.779,8.17c0,0,1.316-2.466-2.048-5.538"
                      transform="translate(-241.472 -4469.209)" fill="none" stroke="#000" stroke-width="1"></path>
                    <path id="Path_434" data-name="Path 434"
                      d="M266.24,4480.923a1.577,1.577,0,0,1,2.654.439l2.319.521-2.633.293a1.548,1.548,0,0,1-1.04.316.6.6,0,0,1-.5-.676.475.475,0,0,1,.923-.133"
                      transform="translate(-261.801 -4478.353)" fill="none" stroke="#000" stroke-width="1"></path>
                    <path id="Path_435" data-name="Path 435"
                      d="M264.516,4495.392s.675,2.5-.1,4.006a3.949,3.949,0,0,1-2.806,1.75"
                      transform="translate(-258.005 -4490.699)" fill="none" stroke="#000" stroke-width="1"></path>
                  </g>
                </g>
              </svg>

              <div class="mx-auto mt-2 leading-4 text-15 max-w-24">
                Subscribe & Save 30%+

              </div>
            </div> -->
            <div :class="state.active.packs == 0 ? 'opacity-30' : ''">
              <svg role="presentation" class="mx-auto w-12 sm:w-auto" xmlns="http://www.w3.org/2000/svg" width="27.946" height="31.061"
                viewBox="0 0 27.946 24.193">
                <g id="Group_4206" data-name="Group 4206" transform="translate(0.356 0.351)">
                  <path id="Path_701" data-name="Path 701" d="M5741.395,1017.369h22.9v20.41h-7.737"
                    transform="translate(-5737.206 -1015.937)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_702" data-name="Path 702" d="M5737.843,1071.652h-7.661v-6.68"
                    transform="translate(-5729.228 -1049.81)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_703" data-name="Path 703" d="M5726.874,1024.44l3.552,3.34,5.937-5.726-9.489-9.648"
                    transform="translate(-5726.874 -1012.406)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_704" data-name="Path 704"
                    d="M5745.947,1049s1.641,2.365,3.813,2.1,2.2-.314,2.8,0,4.1,1.906,4.1,1.906-1.014,1.858-2.679,1.182a16.472,16.472,0,0,1-2-.893s-1.375.169-.41,1.231,5.092,5.453,5.092,5.453.482,1.665-1.014,1.761-7.915,0-7.915,0-.579.072-1.3-.917l-3.137-3.885a2.8,2.8,0,0,1-.314-2c.193-1.327-1.4-1.641-1.4-1.641"
                    transform="translate(-5737.337 -1038.442)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_705" data-name="Path 705" d="M5781.756,1087.5l1.473,1.689"
                    transform="translate(-5765.926 -1065.84)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_706" data-name="Path 706" d="M5781.756,1087.5l1.473,1.689"
                    transform="translate(-5768.234 -1065.84)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_707" data-name="Path 707" d="M5781.756,1087.5l1.473,1.689"
                    transform="translate(-5770.83 -1065.84)" fill="none" stroke="#000" stroke-width="1"></path>
                  <path id="Path_708" data-name="Path 708" d="M5766.215,1017.369v2.8h6.129v-2.8"
                    transform="translate(-5754.868 -1015.937)" fill="none" stroke="#000" stroke-width="1"></path>
                </g>
              </svg>
              <div class="mx-auto mt-2 leading-4 text-15 max-w-20">

                Free Shipping


              </div>
            </div>
          </div>
        </div>
    
        <div data-option-section class="inset-0 mx-auto w-full lg:w-7/12 lg:bg-lifeboost-red-lighter">
          <!-- PRODUCT TABS -->
          <div class="px-2 pt-6 w-full md:px-5" id="first-class-swatch">
            <div class="mx-auto max-w-2xl counter-reset md:px-5 xl:max-w-3xl parent-element">
              <div class="relative pl-16 sm:pl-20 counter-increment md:space-x-8">

                <!-- DESKTOP NAVIGATION -->
                <div class="flex flex-wrap justify-between pt-2 w-full text-center">
                  <div class="grid grid-cols-1 gap-x-2 gap-y-4 mb-3 w-full sm:grid-cols-3 xl:mb-10 sm:gap-x-4">
                    <div class="relative w-full rounded-md border border-gray-400 hover:shadow-lg"
                      v-for="(item, index) in FilteredPacks" :class="state.active.packs == index ? 'bg-white' : ''">
                      <svg
                        class="absolute top-0 left-1/2 transform -translate-x-1/2 -mt-2.5 w-5 h-auto transition-opacity z-[9]"
                        :class="state.active.packs == index ? '' : 'opacity-0'" xmlns="http://www.w3.org/2000/svg"
                        width="47.832" height="47.832" viewBox="0 0 47.832 47.832">
                        <circle id="Ellipse_165" data-name="Ellipse 165" cx="23.916" cy="23.916" r="23.916"
                          fill="#fe3c38">
                        </circle>
                        <path id="Path_1024" data-name="Path 1024" d="M1691.839,1533.375l5.9,5.9,14.016-14.016"
                          transform="translate(-1677.879 -1508.349)" fill="none" stroke="#fff" stroke-width="2"></path>
                      </svg>
                      <label @click="setPack(index)" class="block relative order-2 py-4 font-medium cursor-pointer sm:py-8" :data-testid="'step3-choice-'+index"
                        :data-index="index"><input type="radio" :value="index" name="step3" class="hidden"
                          v-model="state.active.packs" v-bind:id="index">
                        <span class="absolute inset-0 z-0 bg-transparent rounded-md"
                          :class="state.active.variants == packs ? 'bg-white' : ''"></span>
                        <div class="relative mb-2 showcolor-white">
                          <p class="text-sm font-semibold md:text-base xl:text-18 font-ww-medium"
                            v-text="item.Name">
                          </p>
                        </div>

                        <div class="sm:h-8">
                          <div class="px-1 py-0.5 mx-auto text-sm text-white rounded-xl bg-lifeboost-red-300 max-w-24"
                            v-if="index != 0 " v-text="item.SaleRibbon">
                             
                          </div>
                        </div>

                        <div>
                          <p class="text-2xl font-normal uppercase md:text-3xl xl:text-4xl price-frosted-cookie"
                            v-html="item.Price">
                          </p>
                        </div>

                        <div class="mt-2 sm:mt-4">
                          <p v-html="item.Offer" class="text-sm text-gray400 md:text-base xl:text-15 font-ww-medium">

                          </p>
                        </div>
                      </label>
                    </div>
                  </div>
                  <!-- <div class="flex flex-row w-full">
                    <div class="w-1/2" v-for="(item, index) in FilteredPacks">
                      <div
                        class="flex flex-col px-2.5 text-sm tracking-tight text-left text-gray-500 xl:w-auto 2xl:px-8 lg:text-base xl:text-lg"
                        v-html="item.Offer"></div>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="relative pb-14 pl-16 sm:pl-20 md:space-x-8 counter-increment">

                <div class="flex gap-6 pt-2 pb-2 text-center">
                  <template v-for="(item, index) in state.variants">
                    <label role="button" tabindex="0" @click="setType(index)" :data-testid="'step2-choice-'+index"
                      :class="state.active.variants == index ? 'bg-white' : ''"
                      class="relative p-3.5 w-6/12 min-w-min font-medium rounded-lg border border-gray-400 duration-300 ease-out cursor-pointer hover:scale-110"
                      data-option="item.Name.replace(' ','')">
                      <svg
                        class="absolute top-0 left-1/2 -mt-2.5 w-5 h-auto transition-opacity transform -translate-x-1/2"
                        :class="state.active.variants == index ? '' : 'opacity-0'" xmlns="http://www.w3.org/2000/svg"
                        width="47.832" height="47.832" viewBox="0 0 47.832 47.832">
                        <circle id="Ellipse_165" data-name="Ellipse 165" cx="23.916" cy="23.916" r="23.916"
                          fill="#fe3c38">
                        </circle>
                        <path id="Path_1024" data-name="Path 1024" d="M1691.839,1533.375l5.9,5.9,14.016-14.016"
                          transform="translate(-1677.879 -1508.349)" fill="none" stroke="#fff" stroke-width="2"></path>
                      </svg>
                      <span
                        class="hidden absolute inset-0 -m-0.5 rounded-lg border-2 border-lifeboost-yellow-light bg-lifeboost-yellow-light show"
                        style="z-index: -1"></span>
                      <p class="text-base opacity-75 xl:text-lg font-ww-medium" v-text="item.Name"></p>
                    </label>
                  </template>
                </div>
              </div>
              <svg width="0" height="0" class="hidden">
                <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.099 19.261" id="star">
                  <path
                    d="M20.046 7.278a1.067 1.067 0 0 0-.919-.734l-5.8-.527L11.033.649a1.069 1.069 0 0 0-1.966 0L6.774 6.018l-5.8.527a1.07 1.07 0 0 0-.61 1.869l4.386 3.845-1.293 5.7a1.068 1.068 0 0 0 1.59 1.155l5-2.992 5 2.992a1.069 1.069 0 0 0 1.591-1.155l-1.293-5.7 4.39-3.845a1.07 1.07 0 0 0 .312-1.136Zm-9.9 8.783">
                  </path>
                </symbol>
              </svg>
              <div class="relative sm:pl-20 pl-16 counter-increment after:!h-0">
                <div class="relative bottom-12 mx-auto max-w-2xl text-center xl:max-w-3xl">
                  <div class="flex flex-col pb-3">
                    <div class="sm:!text-3xl !text-2xl sale-price-frosted-cookie" v-html="FilteredPacks[state.active.packs].Price"></div>
                    <div class="font-bold text-green-500 md:text-base text-15">
                      {{ FilteredPacks[state.active.packs].Discount }}
                    </div>
                   
                  </div>
                  <button @click="addToCart($event)" data-testid="cta-button"
                    class="relative pt-2.5 pb-3.5 w-full text-sm whitespace-nowrap cursor-pointer btn-red xl:text-2xl md:text-xl font-ww-medium"
                    type="button"
                    >
                    Continue to Checkout
                    <svg class="absolute inset-y-0 right-4 my-auto w-auto md:right-6 lg:h-4 xl:h-auto"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                      width="16px" height="29px">
                      <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                        d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z" />
                    </svg>
                  </button>
                  <p class="pt-2 text-sm text-center text-gray-500">100% MONEY-BACK GUARANTEED</p>
                  <nuxt-img width="424" height="41" format="webp" 
              src="assets/images/pay.png"
              alt="product swatch" class="pt-2.5 mx-auto w-64 max-w-xs mix-blend-darken sm:w-auto" loading="lazy"
              />
                 
                </div>

              </div>
            </div>


          </div>

        </div>
        <div class="flex items-center justify-center customPopup2 relative w-full h-full z-[999] left-0 top-0 hidden"
          v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
          <div id="modal_1"
            class="flex overflow-auto fixed top-0 z-50 items-center w-full h-screen bg-gray-800 bg-opacity-50">
            <div
              class="flex justify-center items-center px-4 py-20 w-full max-w-6xl 2xl:mx-auto md:px-20 xs-max:relative xs-max:top-36">
              <div
                class="flex relative flex-col justify-center items-center px-4 py-14 w-full max-w-screen-lg bg-white border-t-8 border-yellow-600 shadow-lg md:w-auto lg:px-12 xl:px-16">
                <div class="w-full modal-header">
                  <div class="flex justify-between mb-2 space-x-3 w-full text-sm font-semibold">
                    <div class="item">Add to Cart</div>
                    <div class="text-center item sm:text-left">Upgrade Options</div>
                    <div class="text-right item">Secure Checkout</div>
                  </div>
                  <div class="mb-6 w-full progress progress-striped active">
                    <div class="progress-bar progress-bar-success" :class="modal.crosssell.show ? 'w-3/4' : 'w-1/2'">
                      <span>&nbsp;</span>
                    </div>
                  </div>
                </div>
                <!-- modal body 1 start -->
                <div class="w-full modal-body" v-show="modal.upsell.show">
                  <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
                    <p class="m-0 text-lg lg:text-lg xl:text-xl" v-text="state.upgrade.UpSell.PreHeader"></p>
                    <p class="m-0 mx-auto w-full text-lg font-bold text-center uppercase opacity-75 md:w-4/5 sm:text-2xl md:text-3xl lg:text-4xl font-ww-medium"
                      v-text="state.upgrade.UpSell.Header"></p>
                  </div>
                  <div class="flex items-center px-0 mt-10 space-x-4 md:space-x-8">
                    <div class="w-8/12 h-auto item md:w-2/3">
                      <h1 role="main"
                        class="text-2xl font-semibold leading-7 text-left text-gray-800 lg:text-3xl lg:leading-9">
                        Lucky You!
                      </h1>
                      <div data-body-copy>
                        <!-- You’ve found our
      <span class="italic">New Customer Special</span> - our
      biggest savings anywhere in our store. -->
                        <p class="mt-2 text-lg font-normal text-justify sm:text-xl"
                          v-text="state.upgrade.UpSell.SubHeader">
                        </p>
                        <!-- <p v-if="state.upgrade.Discount" class="mt-2 text-lg font-normal sm:text-xl" v-html="state.upgrade.Discount"></p> Todo: Fix this: Enable and check Healthy Coffee 23 in sale stack -->
                      </div>
                    </div>
                    <div class="w-4/12 h-auto item md:w-1/3">
                      <img class="mx-auto" loading="lazy" :src="state.upgrade.UpSell.Image" />
                    </div>
                  </div>
                  <div class="space-y-3 w-full text-center sm:px-5 md:space-y-4">
                    <a @click="setChoice(true)" class="btn--special">Yes!
                      Upgrade My Savings
                      <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 16 29" width="16px" height="29px">
                        <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                          d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                        </path>
                      </svg>
                    </a>
                  </div>
                  <a @click="setChoice(false)" href="javascript:void(0)"
                    class="block text-base leading-none text-center text-gray-800 border-b border-transparent focus:outline-none">No
                    thanks, I’ll pass on this one-time offer</a>
                  <button @click="setChoice(false)"
                    class="absolute top-4 right-4 text-gray-800 cursor-pointer lg:top-6 lg:right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                    aria-label="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      ...
                    </svg>
                  </button>
                </div>
                <!-- modal body 1 end -->
                <!-- modal body 2 start -->
                <div class="w-full modal-body" v-show="modal.crosssell.show">
                  <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
                    <!-- Save $30 When You Add Our
                    <span class="italic">Signature Roast Bundle</span> to Your Order -->
                    <p class="px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 sm:text-2xl md:text-3xl lg:text-3xl font-ww-medium"
                      v-text="state.upgrade.CrossSell.Header"></p>
                  </div>
                  <div class="flex items-center px-2 mt-10 space-x-4 md:space-x-8">
                    <div class="w-8/12 h-auto item md:w-2/3">
                      <!-- Try all three of our most popular roasts at a huge discount.
                    Enjoy our delicious organic Medium Roast, Dark Roast, and
                    Espresso Roast. All are shade grown, high-elevation grown,
                    tested for over 400 toxins, low acid, and d-e-l-i-c-i-o-u-s! -->
                      <p class="mt-2 text-lg font-normal text-justify sm:text-xl" v-text="state.upgrade.CrossSell.Body">
                      </p>
                      <!-- <s>$104.85</s> $74.85
                    <strong class="italic">(Save $30!)</strong> -->
                      <p class="mt-2 text-lg font-normal sm:text-xl" v-html="state.upgrade.CrossSell.PricenSave"></p>
                    </div>
                    <div class="w-4/12 h-auto item md:w-1/3">
                      <img class="mx-auto" loading="lazy" :src="state.upgrade.CrossSell.Image" />
                    </div>
                  </div>
                  <div class="px-5 space-y-3 w-full text-center md:space-y-4">
                    <a @click="setChoice(true)" data-add-upgrade-bundle class="btn--special">Yes!
                      Upgrade My Order
                      <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 16 29" width="16px" height="29px">
                        <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                          d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                        </path>
                      </svg>
                    </a>
                  </div>
                  <a @click="setChoice(false)" data-add-default-final href="javascript:void(0)"
                    class="block text-sm leading-none text-center text-gray-800 border-b border-transparent focus:outline-none">
                    No thanks, I’ll pass on this opportunity to try these three roasts
                    at a big discount…
                  </a>
                  <button @click="setChoice(false)"
                    class="absolute top-6 right-6 text-gray-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                    aria-label="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      ...
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Engine from "~/composables/Engine.js";

const props = defineProps({
  title: {
    type: String,
    default: 'GET UP TO <u>58% OFF</u> YOUR ORDER -\n' +
      '        WHILE SUPPLIES LAST!',
  },
  subTitle: {
    type: String,
    default: '(WE’LL EVEN PAY FOR THE SHIPPING!)',
  },
  status: {
    type: String,
    default: 'Current status:',
  },
  status2: {
    type: String,
    default: 'Your order will ship today.',
  },
  timeText: {
    type: String,
    default: 'Hurry, this deal ends in:',
  },
  slides: {
    type: Array,
    default: () => [
      {
        imgSrc: "assets/images/swiper-img-1.jpg",
        imgAlt: "image 1",
      },
      {
        imgSrc: "assets/images/swiper-img-2.jpg",
        imgAlt: "image 2",
      },
      {
        imgSrc: "assets/images/swiper-img-3.jpg",
        imgAlt: "image 3",
      },
      {
        imgSrc: "assets/images/swiper-img-4.jpg",
        imgAlt: "image 4",
      },
    ],
  },
});
// counter
const counter = ref({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});




const runEngine = new Engine();
const route = useRoute();
const page = ref({ Products: { data: {} }, AOVBooster: [], PreselPack: null });
page.value = await runEngine.queryPage(
  route.path.split("/").at(-1).split("?")[0]
);
const products = computed(() => {
  return Object.keys(page.value.Products).reduce(
    (r, v) => ({ ...r, [v]: page.value.Products[v] }),
    {}
  );
});

const upgrades = computed(() =>
  page.value.AOVBooster.length ? page.value.AOVBooster[0] : []
);
const Preselected = computed(() =>
  page.value.PreselPack !== null ? page.value.PreselPack - 1 : 0
);

const highlightCheckbox = ref(false);
const checkboxChecked = ref(false);

const state = reactive({
  layout: ref(""),
  layoutPopup: ref(""),
  subscriptionPage: ref(false),
  pageSteps: ref({
    stepOne: page.value.step1,
    stepTwo: page.value.step2,
    stepThree: page.value.step3,
  }),
  items: products,
  upgrades: upgrades,
  variants: products.value[0].Variants,
  packs: products.value[0].Variants[0].Pack.filter((obj) => obj.Active),
  images: products.value[0].Variants[0].variant.Gallery[0],
  unit: {
    beans: ["bag", "bags"],
    pods: ["box", "boxes"],
    ground: ["bag", "bags"],
    wholebeans: ["bag", "bags"],
    coffeeground: ["bag", "bags"],
    coffeebeans: ["bag", "bags"],
    coffeepods: ["box", "boxes"],
    groundcoffee: ["bag", "bags"],
  },
  currentUnit: ref(["bag", "bags"]),
  active: {
    items: 0,
    variants: 0,
    packs: Preselected.value,
    sellingPlan: 0,
  },
  upgrade: ref({
    UpSell: {},
    CrossSell: {},
    show: false,
  }),
  isSubscription: page.value.Subscription ?? false,
  regular: ref({}),
  trackingStack: ref({}),
});

const FilteredPacks = computed(() => {
  return state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
});
// Modal object
const modal = reactive({
  show: true,
  page: true,
  product: {
    qty: 0,
    packName: "",
    Coupon: [],
    variantID: 40029155524668,
  },
  upsell: {
    show: true,
    activate: false,
  },
  crosssell: {
    show: false,
    variantId: 32453656150076,
    activate: false,
  },
});

// const setProduct = (index) => {
//   const newPacks = products.value[index].Variants[0].Pack.filter((obj) => obj.Active);
// state.packs.splice(0, state.packs.length, ...newPacks);
//     }
// console.log(modal.upsell.show);
// Methods
const setProductModal = (input) => {
  modal.product = {
    qty: input.qty,
    packName: input.packName,
    Coupon: input.Coupon,
    variantID: input.variantID,
  };
  modal.crosssell.variantId = input.crossSellID;
};

const trackEvent = inject("trackEvent");

const setProduct = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = parseInt(index);
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = parseInt(Preselected.value);

};
const setType = (index) => {
  state.active.variants = parseInt(index);

  state.images =
    state.items[state.active.items].Variants[
      state.active.variants
    ].variant.Gallery[0];

  // Refresh packs for the new variant
  state.packs = state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);

  // Keep the same pack index; clamp if now out of range
  if (state.active.packs >= state.packs.length) {
    state.active.packs = Math.max(0, state.packs.length - 1);
  }
};

const setPack = (index) => {
  state.active.packs = parseInt(index);
};
const getRoast = (str) => {
  str = str.toLowerCase()
  return str.includes('light') ? '#edd596' : str.includes('medium') ? '#a9a93d' : str.includes('dark') ? '#505011' : str.includes('decaf') ? '#c19862' : '#edd596'
}
const activePack = (index) => {
  return state.active.packs === index;
};
const setChoice = (choice) => {
  if (modal.upsell.show === true) {
    modal.upsell.activate = choice;

    // track upsell offer decision
    if (choice) {
      trackOffer.accept({
        id: 1,
        name: 'Double Order Upsell'
      });
    } else {
      trackOffer.decline({
        id: 1,
        name: 'Double Order Upsell'
      });
    }

    modal.upsell.show = false;
    modal.crosssell.show = true;

    // track cross-sell view
    trackOffer.view({
      id: 2,
      name: 'Signature Bundle Cross-sell' // Double Order or Signature Bundle
    });
  } else if (modal.crosssell.show === true) {

    modal.crosssell.activate = choice;

    // track cross-sell offer decision
    if (choice) {
      trackOffer.accept({
        id: 2,
        name: 'Signature Bundle Cross-sell'
      });
    } else {
      trackOffer.decline({
        id: 2,
        name: 'Signature Bundle Cross-sell'
      });
    }
    checkOut();
  }
};


const checkOut = () => {
  const crossSellId = modal.crosssell.activate && modal.crosssell.variantId;
  runEngine.checkout(
    modal.product.variantID,
    modal.upsell.activate ? modal.product.qty * 2 : modal.product.qty,
    modal.upsell.activate ? modal.product.Coupon[0] : modal.product.Coupon[1],
    modal.product.packName,
    null,
    crossSellId,
    trackEvent
  );

};

const replaceUnit = (str, convert) => {
  const units = state.currentUnit
  const toConverts = state.unit[convert]
  const unitsCapital = units.map(unit => unit.charAt(0).toUpperCase() + unit.slice(1))
  const toConvertCapital = toConverts.map(unit => unit.charAt(0).toUpperCase() + unit.slice(1))
  state.currentUnit = state.unit[convert]
  return str.replaceAll(new RegExp(`${unitsCapital[1]}`, 'g'), toConvertCapital[1]).replaceAll(new RegExp(`${unitsCapital[0]}`, 'g'), toConvertCapital[0]).replaceAll(new RegExp(`${units[1]}`, 'g'), toConverts[1]).replaceAll(new RegExp(`${units[0]}`, 'g'), toConverts[0])
}

const setProductDetails = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = index;
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = Preselected.value;
};

const setPrice = (item) => {
  const amount = item.PackSize.replace("x", "");
  const sale =
    state.variants[state.active.variants].variant.VariantPrice;
  return "$" + (amount * sale).toFixed(2);
};

const addUpgradeToCart = (accepted) => {
  accepted ? onCheckout(state.upgrade) : onCheckout(state.regular);
};

const onCheckout = (Item) => {
  runEngine.checkout(
    Item.varID,
    Item.quantity,
    Item.Coupon,
    Item.pack,
    null,
    null,
    trackEvent
  );
};

const stockCheck = () => {
  return state.items[state.active.items].Variants[state.active.variants].variant
    .inStock;
};

const hasSellingPlans = () => {

  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans.length > 0;
}
// gid://shopify/SellingPlan/970981436
const getSellingPlan = () => {
  // return the last selling plan id example from gid://shopify/SellingPlan/970981436 return only 970981436
  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans[state.active.sellingPlan].sellingPlan.id.split("/").at(-1);
}

const getStep = (step) => {
  switch (step) {
    case 1:
      return "Step 1";
    case 2:
      return Object.keys(state.items).length > 1 ? "Step 2" : "Step 1";
    case 3:
      return Object.keys(state.items).length > 1 && state.variants.length > 1
        ? "Step 3"
        : Object.keys(state.items).length > 1 || state.variants.length > 1
          ? "Step 2"
          : "Step 1";
    default:
      return "";
  }
};

// Lifecycle hook onMounted (equivalent to init in Alpine.js)
onMounted(() => {
  runEngine.fetchProduct(["6938980876348", "6980372004924", "7148455624764", "8023271014460"]).then(() => {
    Object.keys(state.items).map((key) => {
      return state.items[key].Variants.map((variant, index) => {
        state.items[key].Variants[index].variant.inStock =
          runEngine.getInStock(variant.variant.VariantID);
        state.items[key].Variants[index].variant.SellingPlans =
          runEngine.getVariant(variant.variant.VariantID).sellingPlanAllocations.nodes;
      });
    });
  });


  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(0, 0, 0, 0)
  const countDownDate = new Date(tomorrow).getTime()
  const x = setInterval(() => {
    const now = new Date().getTime()
    const distance = countDownDate - now
    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)
    counter.value.days = days
    counter.value.hours = hours
    counter.value.minutes = minutes
    counter.value.seconds = seconds
    if (distance < 0) {
      clearInterval(x)
    }
  }, 1000)
});
const addToCart = () => {
  const item = state.items[state.active.items];
  const variant = item.Variants[state.active.variants];
  const pack = variant.Pack[state.active.packs];
  const variantID = variant.variant.VariantID;

  if (typeof state.upgrades.CrossSellOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter(
      (obj) => obj.PackSize === "x" + pack.PackSize.replace("x", "") * 2
    );
    const oferTa = upgradeOffer[0] ? upgradeOffer[0] : pack;
    const CrossSellVariant = JSON.parse(
      state.upgrades.CrossSellOffer.VariantId.VariantSKU
    )[variant.Name.toLowerCase().includes("bean") ? "beans" : "ground"];
    setProductModal({
      qty: pack.PackSize.replace("x", ""),
      packName: pack.Name,
      Coupon: [oferTa.Coupon, pack.Coupon],
      variantID: variantID,
      crossSellID: CrossSellVariant,
    });
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: pack.PackSize.replace("x", "") * 2,
      PackDiff: pack.PackSize.replace("x", "") / 2,
      UpSell: {
        PreHeader: state.upgrades.UpsellOffer.PreHeader,
        Header: state.upgrades.UpsellOffer.Header,
        SubHeader: state.upgrades.UpsellOffer.SubHeader,
        Image: state.upgrades.UpsellOffer.Image.url,
        ButtonText: "Yes! Upgrade My Order",
      },
      CrossSell: {
        Body: state.upgrades.CrossSellOffer.Body,
        Header: state.upgrades.CrossSellOffer.Header,
        Image: state.upgrades.CrossSellOffer.Image.url,
        PricenSave: state.upgrades.CrossSellOffer.PricenSave,
        ButtonText: "Yes! Upgrade My Order",
      },
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      show: true,
    };
  } else if (typeof state.upgrades.UpsellPackOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const xUpgradeQty = state.upgrades.UpsellPackOffer.filter(
      (obj) => obj.PackSizeRun === pack.PackSize
    );
    const oferTi = xUpgradeQty[0];

    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter((obj) => obj.PackSize === oferTi.PackUpgrade);
    const oferTa = upgradeOffer[0] ? upgradeOffer[0] : pack;
    if (state.layoutPopup == "L02") {
      setProductModal({
        qty: pack.PackSize.replace("x", ""),
        packName: pack.Name,
        Coupon: [oferTa.Coupon, pack.Coupon],
        variantID: variantID,
      });
    }
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: oferTi.PackUpgrade.replace("x", ""),
      PackDiff:
        oferTi.PackUpgrade.replace("x", "") -
        oferTi.PackSizeRun.replace("x", ""),
      PreHeader: oferTi.PreHeader,
      Header: oferTi.Header,
      SubHeader: oferTi.SubHeader,
      Image: oferTi.Image.url,
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      ButtonText: oferTi.ButtonText,
      show: true,
    };
    state.regular = {
      product: item.Name,
      variant: variant.Name,
      pack: pack.Name,
      quantity: pack.PackSize.replace("x", ""),
      Coupon: pack.Coupon,
      varID: variantID,
    };
  } else if (state.isSubscription && hasSellingPlans()) {
    runEngine.checkout(
      variantID,
      pack.PackSize.replace("x", ""),
      pack.Coupon,
      pack.Name,
      getSellingPlan(),
      null,
      trackEvent
    );
  } else {
    runEngine.checkout(
      variantID,
      pack.PackSize.replace("x", ""),
      pack.Coupon,
      pack.Name,
      null,
      null,
      trackEvent
    );
  }
};

const handleButtonClick = () => {
  if (!checkboxChecked.value && state.isSubscription) {
    highlightCheckbox.value = true;
  } else {
    addToCart();

    // track upsell offer view
    trackOffer.view({
      id: 1,
      name: 'Double Order Upsell' // Double Order or Signature Bundle
    });

  }
};



defineBuilderComponent({
    friendlyName: 'Swatches Type 3'
})
</script>

<style scoped>
.swiper-pagination-bullet-active {
  background: #ef4444 !important;
}

.swiper-pagination-bullet {
  background: white;
  opacity: 1;
}

/* .counter-reset .counter-increment {
  position: relative;
  padding-left: 45px;
} */

.parent-element {
  counter-reset: section 0;
  /* Start counting from 1 */
}




.counter-reset .counter-increment:before {
  @apply content-[counter(section)] absolute w-[45px] h-[45px] leading-10 text-center text-[#5a3b36] text-2xl rounded-[45px] border-2 border-solid border-[#5a3b36] left-0 top-2.5;
  counter-increment: section;
}



/* label input:checked~.showbg.cath {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

label input:checked~.showbg {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
} */

label input:checked~.showcolor-white {
  @apply bg-white text-black
}

/* label input:checked~ .transition-opacity {
  @apply opacity-100
} */

.counter-increment {
  position: relative
}

.counter-increment:after {
  @apply content-[""] absolute h-[calc(100%_-_63px)] border-l-black border-l border-solid left-[22.5px] bottom-0;
}

.sale-price-frosted-cookie s {
  @apply mr-2 !font-normal sm:text-xl text-lg
}


</style>